module.exports = __webpack_public_path__ + "static/media/LWT_Logo.dc94f69d.svg";